import React from 'react';
import { CtaButton } from './CtaButton';
import { Countdown } from './Countdown';
import { ScarcityBar } from './ScarcityBar';
export function FinalCta() {
  return <section className="w-full bg-ink px-5 py-16 sm:px-8 md:py-20" data-id="element-115" data-mp="vhivm2qc9gay">
      <div className="mx-auto max-w-2xl text-center" data-id="element-116" data-mp="19gih51ik1f2w">
        <h2 className="font-display text-[28px] font-bold leading-tight text-cream sm:text-4xl" data-id="element-117" data-mp="15cub4n9kmrjr">
          Ready to stop second-guessing and start planning your anterior cases with a system?
        </h2>

        <p className="mt-6 text-[12px] font-semibold uppercase tracking-[0.14em] text-cream/60" data-id="element-118" data-mp="1eek2jt3gdqhj">
          Start organizing your
        </p>
        <p className="mt-3 rounded-2xl border border-gold/30 bg-ink-soft px-4 py-5 text-[12px] font-bold uppercase leading-relaxed tracking-[0.1em] text-gold-light sm:text-sm" data-id="element-119" data-mp="1t2ercyecbapc">
          Case → Material → Shade → Opacity → Layering → Anatomy → Sequence
        </p>

        <div className="mt-8" data-id="element-120" data-mp="1x5b8sls590rp">
          <CtaButton label="Get Resin Architect™" data-id="element-121" data-mp="1x64edjfd9k89" />
          <p className="mt-3 text-[13px] leading-relaxed text-cream/70" data-id="element-122" data-mp="n64abl04tmkc">
            Just $27 · Instant access · Lifetime access · 7-day guarantee
          </p>
          <p className="mt-1 text-[12px] italic text-cream/50" data-id="element-123" data-mp="s6s1q7s9w5f3">
            Your currency is converted automatically at checkout.
          </p>
        </div>

        <Countdown className="mt-10" tone="dark" data-id="element-124" data-mp="123wnw7m4c0vw" />

        <ScarcityBar className="mt-8" tone="dark" data-id="element-125" data-mp="120inv60xg3rm" />
      </div>
    </section>;
}